import { readPersistedSessionIds } from './sessionIds';
import {
    emptyUserInstancePrefs,
    mergeUserInstancePrefsPatch,
    readUserInstancePrefsDoc,
} from './userInstancePrefs';
import { emptyUserPrefsV1, mergeUserPrefsPatch, readUserPrefsDoc } from './userPrefs';

const DEFAULT_EXPLOITATION = {
    screenings: false,
    tasks: false,
    programmation: false,
};

function read_exploitation_blob(userId, instanceId) {
    const doc = readUserInstancePrefsDoc(userId, instanceId) || emptyUserInstancePrefs();
    const blob = doc.filtersExpandedUi;
    if (!blob || typeof blob !== 'object') {
        return { ...DEFAULT_EXPLOITATION };
    }
    return {
        screenings: blob.screenings === true,
        tasks: blob.tasks === true,
        programmation: blob.programmation === true,
    };
}

/**
 * @returns {{ exploitation: { screenings: boolean, tasks: boolean, programmation: boolean }, analyses: boolean, lists: boolean }}
 */
export function readPersistedFiltersExpandedUi() {
    const out = {
        exploitation: { ...DEFAULT_EXPLOITATION },
        analyses: false,
        lists: false,
    };
    if (typeof window === 'undefined' || !window.localStorage) {
        return out;
    }
    try {
        const { userId, instanceId } = readPersistedSessionIds();
        if (userId) {
            out.exploitation = read_exploitation_blob(userId, instanceId);
        }
        if (userId) {
            const user_doc = readUserPrefsDoc(userId) || emptyUserPrefsV1();
            if (user_doc.analysesStatsFiltersExpanded === true) {
                out.analyses = true;
            }
            if (user_doc.listFiltersExpanded === true) {
                out.lists = true;
            }
        }
    } catch {
        /* ignore */
    }
    return out;
}

/**
 * @param {'exploitation.screenings'|'exploitation.tasks'|'exploitation.programmation'|'analyses'|'lists'} scope
 * @param {boolean} expanded
 * @param {string|null|undefined} userId
 * @param {string|null|undefined} instanceId
 */
export function persistFiltersExpandedScope(scope, expanded, userId, instanceId) {
    if (!userId || !scope) {
        return;
    }
    const v = Boolean(expanded);
    if (scope === 'analyses') {
        mergeUserPrefsPatch(userId, { analysesStatsFiltersExpanded: v });
        return;
    }
    if (scope === 'lists') {
        mergeUserPrefsPatch(userId, { listFiltersExpanded: v });
        return;
    }
    const key = scope.startsWith('exploitation.') ? scope.slice('exploitation.'.length) : null;
    if (!key || !Object.prototype.hasOwnProperty.call(DEFAULT_EXPLOITATION, key)) {
        return;
    }
    const cur = read_exploitation_blob(userId, instanceId);
    mergeUserInstancePrefsPatch(userId, instanceId, {
        filtersExpandedUi: {
            ...cur,
            [key]: v,
        },
    });
}
